import { ReactNode } from "react";
import { Typography } from "@saviynt/design-system";
import { FormattedMessage } from "react-intl";

interface FieldWrapperProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Base wrapper component that provides consistent styling for all form fields
 * This ensures new field types from backend automatically get consistent styling
 */
export function FieldWrapper({
  label,
  required,
  children,
  className = "",
}: FieldWrapperProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <Typography kind="label">
          {label}
          {required && (
            <span className="text-[var(--color-foreground-warning-medium,#a36a00)] ml-1">
              <FormattedMessage
                id="+uGQkt"
                defaultMessage="*"
                description="Required field indicator"
              />
            </span>
          )}
        </Typography>
      )}
      {children}
    </div>
  );
}
